import './App.css';

import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';


import Home from "./components/pages/Home";
import Footer from "./components/inc/Footer";
import Deluxeroom from './components/pages/Deluxeroom';
import Kingroom from './components/pages/Kingroom';
import Cottageroom from './components/pages/Cottageroom';
import Vegas106 from './components/pages/Vegas106';
import SuperDeluxe from './components/pages/SuperDeluxe';
import Vinodini204 from './components/pages/Vinodini204';
import Vanya104 from './components/pages/Vanya104';
import Gallerypage from './components/pages/Gallerypage';
import Contactus from './components/pages/Contactus';
import Reception from './components/pages/Reception';
import Corporatepage from './components/pages/Corporatepage';
import Restaurantpage from './components/pages/Restaurantpage';
import Vintagecafe from './components/pages/Vintagecafe';
import Restrovilas from './components/pages/Restrovilas';
import Suitroom from './components/pages/Suitroom';


function App() {
  return (
    <Router>
    
    <div>
    
      <Routes>

      <Route axact path="/" element={<Home/>}/>
      <Route axact path="/deluxe-room" element={<Deluxeroom/>}/>
      <Route axact path="/king-room" element={<Kingroom/>}/>
      <Route axact path="/cottage-room" element={<Cottageroom/>}/>
      <Route axact path="/family-room" element={<Vegas106/>}/>
      <Route axact path="/Super-deluxe-room" element={<SuperDeluxe/>}/>
      <Route axact path="/superdeluxroom" element={<Vinodini204/>}/>
      <Route axact path="/Vanya104-room" element={<Vanya104/>}/>
      <Route axact path="/gallery" element={<Gallerypage/>}/>
      <Route axact path="/Contact-us" element={<Contactus/>}/>
      <Route axact path="/corpoarte-meeting" element={<Corporatepage/>}/>

      <Route axact path="/Reception-book" element={<Reception/>}/>
      <Route axact path="/restaurant" element={<Restaurantpage/>}/>
      <Route axact path="/Vintagecafe" element={<Vintagecafe/>}/>
      <Route axact path="/multicuisine-menu" element={<Restrovilas/>}/>

            <Route axact path="/Suitroom" element={<Suitroom/>}/>

      </Routes>
    <Footer/>
  
    </div>

    </Router>
  );
}

export default App;
